import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { ShieldCheck, Lock, CreditCard, Star, XCircle } from 'lucide-react';
export const UrgencyBar = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="bg-bg-card text-txt-primary py-2 md:py-3 px-3 md:px-4 sticky top-0 z-50 border-b border-line" data-id="element-307" data-mp="wr269r9baf2f">
      <div className="max-w-4xl mx-auto flex flex-row items-center justify-center gap-1.5 md:gap-6 text-center text-[11px] md:text-base font-medium" data-id="element-308" data-mp="3v9h9gfd0nhve">
        <div className="flex items-center gap-1 md:gap-2" data-id="element-309" data-mp="44qudkg98rqb">
          <span className="animate-pulse hidden md:inline" data-id="element-310" data-mp="90ppdqw397zp">⏰</span>
          <span className="hidden md:inline" data-id="element-311" data-mp="e0u3xbdfrsna">
            OFERTA DE LANZAMIENTO — CIERRA EN:
          </span>
          <span className="md:hidden" data-id="element-312" data-mp="1khfo6oy6mxja">LANZAMIENTO —</span>
          <span className="font-bold bg-brandYellow/10 px-1.5 md:px-2 py-0.5 md:py-1 rounded text-xs md:text-base text-brandYellow" data-id="element-313" data-mp="1kgmmi2e2yy80">
            {hours.toString().padStart(2, '0')}:
            {minutes.toString().padStart(2, '0')}:
            {seconds.toString().padStart(2, '0')}
          </span>
        </div>
        <span className="text-brandGold font-bold text-[10px] md:text-base" data-id="element-314" data-mp="1c9eitfoy5lb2">
          Después vuelve a su precio original. No vuelve.
        </span>
      </div>
    </div>;
};
export const Hero = () => {
  return <section className="bg-bg-base px-4 pt-4 pb-7 md:pt-16 md:pb-16 overflow-hidden" data-id="element-315" data-mp="ybg8cldqy90u">
      <div className="max-w-[700px] mx-auto text-center space-y-2.5 md:space-y-6" data-id="element-316" data-mp="ydauu44o2971">
        <FadeIn data-id="element-317" data-mp="tin03nj2kik0">
          <div className="space-y-2 md:space-y-4" data-id="element-318" data-mp="olmu1cm7zfsw">
            <div className="inline-flex items-center gap-1.5 bg-bg-card text-brandYellow font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full border border-brandYellow/30" data-id="element-319" data-mp="omg6mu7v0ziy">
              <span className="text-sm md:text-base" data-id="element-320" data-mp="fmt2i0nqxfm7">🛒</span>
              <span className="text-[8.5px]" data-id="element-321" data-mp="an6nblocxpar">
                SISTEMA N°1 PARA VENDEDORES DE ARGENTINA
              </span>
            </div>
            <h1 className="font-hero font-normal uppercase text-[32px] md:text-[72px] leading-[1.0] tracking-[0.5px] text-txt-primary px-2 pt-3 pb-1" data-id="element-322" data-mp="10m8zn5ykv0x">
              POTENCIA TU NEGOCIO
              <br data-id="element-323" data-mp="3n7kjookw26kx" />
              VENDIENDO DE FORMA{' '}
              <span className="text-brandYellow" data-id="element-324" data-mp="3s5m1l66kvzut">DIGITAL.</span>
              <br data-id="element-325" data-mp="jor64bs41hqr" />
              <span data-id="element-326" data-mp="jo7s365kzdi0">DESDE HOY.</span>
            </h1>
            <p className="text-txt-body text-[12.5px] md:text-[16px] leading-[1.4] md:leading-[1.7] font-sans px-3" data-id="element-327" data-mp="jqu7frypqxas">
              6 Tomos · 6 Bonos · Sistema Completo · Todo lo que necesitás para
              vender, rankear y ganar en MeLi Argentina
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-328" data-mp="evy1rp0k0bf7">
          <a href="#pricing" className="block cursor-pointer relative" data-id="element-329" data-mp="12nvedibtv7hd">
            <div className="absolute inset-0 bg-brandYellow/10 blur-[80px] rounded-full" data-id="element-330" data-mp="12lsf07osc1zz"></div>
            <div className="absolute inset-y-0 -inset-x-10 bg-brandGold/10 blur-[60px] rounded-full" data-id="element-331" data-mp="17get4im948nr"></div>
            <img src="https://cdn.magicpatterns.com/uploads/4p7HE5ixBSKoBh4AAubvnx/MOckup_sin_fondo.png" alt="MEGAPACK Comercio Productivo 2026 — Sistema completo para vender en Mercado Libre" loading="eager" decoding="async"
          // @ts-ignore
          fetchpriority="high" className="relative block w-full max-w-[260px] md:max-w-[520px] mx-auto h-auto object-contain hover:-translate-y-1 transition-transform duration-300 drop-shadow-2xl" data-id="element-332" data-mp="2s2e8sd8eg6ky" />
          </a>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-333" data-mp="2i84dons2ou6j">
          <div className="max-w-2xl mx-auto space-y-2.5 md:space-y-5" data-id="element-334" data-mp="2i488u165laiq">
            {/* Chips - same on all screens */}
            <div className="flex flex-wrap gap-1.5 md:gap-2 justify-center items-center" data-id="element-335" data-mp="3tlgc2j52cklb">
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-336" data-mp="3pk4ris11qpjz">
                <span className="text-[10px] md:text-xs" data-id="element-337" data-mp="sq8tjn4ka1vt">📄</span> 100% PDF
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-338" data-mp="xpv7jys7rm5o">
                <span className="text-[10px] md:text-xs" data-id="element-339" data-mp="17o15y6etaa5s">⚡</span> Acceso en 5
                min
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-340" data-mp="1bol3vc77lhsz">
                <span className="text-[10px] md:text-xs" data-id="element-341" data-mp="1le4oamakljpy">📚</span> 6 Tomos
                completos
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-342" data-mp="1qfu1a7hcs7go">
                <span className="text-[10px] md:text-xs" data-id="element-343" data-mp="3fwza9lz8gmbz">🛒</span> Sistema MeLi
                2026
              </span>
            </div>

            {/* CTA button + trust */}
            <div className="space-y-2 md:space-y-3" data-id="element-344" data-mp="35y9srub913w9">
              <CTAButton href="#pricing" fullWidth className="!py-3.5 md:!py-4 !text-[15px] md:!text-base" data-id="element-345" data-mp="30y5bi22io54z">
                🛒 QUIERO EL MEGAPACK AHORA
              </CTAButton>

              <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 text-[9.5px] md:text-xs text-txt-muted font-sans" data-id="element-346" data-mp="3tnuf8n6m2jaa">
                <span className="flex items-center gap-1" data-id="element-347" data-mp="3otzv5in3g2ao">
                  <ShieldCheck size={11} className="text-success" data-id="element-348" data-mp="3jvyh5c4iyt62" /> Garantía 15
                  días
                </span>
                <span className="flex items-center gap-1" data-id="element-349" data-mp="l8anjsll98xc">
                  <Lock size={11} className="text-txt-muted" data-id="element-350" data-mp="gg11innlgt0c" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-351" data-mp="2anv4bo4mmgxy">
                  <CreditCard size={11} className="text-brandGold" data-id="element-352" data-mp="2aqhc9ovfiygp" /> Mercado
                  Pago
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  return <div className="bg-bg-alt border-y border-line py-6" data-id="element-353" data-mp="25w3l5ynsvdhu">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-354" data-mp="1rxvn1nf12653">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x divide-line" data-id="element-355" data-mp="1rwc23jiff6wz">
          <FadeIn delay={0.1} data-id="element-356" data-mp="1w0juprs0970h">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] mb-0.5 text-[#FFE600]" data-id="element-357" data-mp="1hzft7com8irw">
              +500
            </div>
            <div className="text-sm font-sans text-txt-body" data-id="element-358" data-mp="1mzbzxjop6ob5">
              comerciantes confían
            </div>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-359" data-mp="3cbntl5jphrv2">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] mb-0.5 text-[#FFE600]" data-id="element-360" data-mp="3hd3e8whz1wcx">
              6
            </div>
            <div className="text-sm font-sans text-txt-body" data-id="element-361" data-mp="15phua9nzpx6c">Tomos listos</div>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-362" data-mp="10rydb1zwr6ap">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] mb-0.5 text-[#FFE600]" data-id="element-363" data-mp="1ff1djgfm7t1q">
              6
            </div>
            <div className="text-sm font-sans text-txt-body" data-id="element-364" data-mp="1amqbo81bdx6j">
              Bonos incluidos
            </div>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-365" data-mp="1ohiy7qfmgdmm">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] mb-0.5 text-[#FFE600]" data-id="element-366" data-mp="1jh4nu1qjsrlf">
              4.9/5
            </div>
            <div className="text-sm font-sans text-txt-body flex items-center justify-center gap-1" data-id="element-367" data-mp="1yd43bxfzlu0l">
              calificación <Star size={12} className="fill-gold text-gold" data-id="element-368" data-mp="1tcyawf1w83hg" />
            </div>
          </FadeIn>
        </div>
      </div>
    </div>;
};
export const Testimonials1 = () => {
  const testimonials = [{
    initials: 'MR',
    text: 'Por primera vez en años entré a MeLi con todo listo. En la primera semana recuperé lo que pagué y más.',
    author: 'Marcos R.',
    role: 'Comerciante · Bs. As.',
    bg: 'bg-[#FF6B00]'
  }, {
    initials: 'CP',
    text: 'Tenía miedo de lo impositivo. El Tomo 2 me ordenó todo. Ahora vendo tranquila y sé exactamente lo que gano.',
    author: 'Carolina P.',
    role: 'Revendedora · Córdoba',
    bg: 'bg-[#3B82F6]'
  }, {
    initials: 'DG',
    text: 'En 10 minutos armé mi primera publicación profesional. Mis competidores no entienden cómo aparezo primero.',
    author: 'Diego G.',
    role: 'Dueño de negocio · Rosario',
    bg: 'bg-[#10B981]'
  }];
  return <Section className="bg-bg-base" data-id="element-369" data-mp="34eooki6c1gbn">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5 md:gap-4" data-id="element-370" data-mp="34bkfb6e0fue4">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-371" data-mp="jnobekuydez8" data-mpi={i}>
            <div className="bg-bg-card p-3.5 md:p-5 rounded-[14px] md:rounded-[18px] border border-line h-full flex flex-col" data-id="element-372" data-mp="jlv02s9ea6kw">
              <div className="flex items-center gap-2.5 mb-2.5" data-id="element-373" data-mp="247jpi46ocpzb">
                <div className={`w-8 h-8 md:w-9 md:h-9 ${t.bg} text-white rounded-full flex items-center justify-center font-sans font-bold text-[11px] md:text-xs shrink-0`} data-id="element-374" data-mp="204n9ml8ir7z2">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-375" data-mp="1lfhdj64z9xve">
                  <div className="flex text-gold mb-0.5" data-id="element-376" data-mp="1lgiqxh9guwga">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-377" data-mp="1gi8ul3c09pt3" data-mpi={j} />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[12px] md:text-[13px] leading-tight" data-id="element-378" data-mp="17fg2wyywvc2q">
                    {t.author}
                  </p>
                  <p className="text-[10px] md:text-[11px] font-sans text-txt-muted" data-id="element-379" data-mp="36rsjshuwtfw4">
                    {t.role}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[12.5px] md:text-[13.5px] leading-[1.5] italic" data-id="element-380" data-mp="iabtqtetasdu">
                "{t.text}"
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Problem = () => {
  const painPoints = ['Tu negocio físico funciona, pero sentís que estás perdiendo ventas por no estar en Mercado Libre', 'Tenés mercadería parada en el local mientras miles de personas la buscan online todos los días', 'Pasás horas armando publicaciones que no generan ventas y no entendés qué está fallando', 'Querés vender por internet, pero no sabés por dónde empezar', 'Cada mes los costos aumentan, pero las ventas no crecen al mismo ritmo', 'Ves que otros venden todos los días en Mercado Libre y no entendés qué están haciendo diferente', 'Sabés que el comercio está cambiando, pero no querés quedarte atrás mientras otros se llevan tus clientes'];
  return <Section className="bg-bg-alt" data-id="element-381" data-mp="1mlg85mo0kbhy">
      <div className="max-w-[720px] mx-auto" data-id="element-382" data-mp="1mkdj7ka94j4o">
        <FadeIn data-id="element-383" data-mp="1mjln88cqsjdv">
          <h2 className="font-display font-extrabold uppercase md:text-[44px] text-center mb-8 text-txt-primary text-[28px]" data-id="element-384" data-mp="1rbwphhuygh9l">
            Si tenés un <span className="text-[#FFE600]" data-id="element-385" data-mp="1dm1ksw358h1o">negocio,</span>
            <br data-id="element-386" data-mp="1ijl9yr1dqe8e" />
            esto te va a sonar familiar...
          </h2>

          <div className="space-y-2 md:space-y-3 mb-10" data-id="element-387" data-mp="1ihgxvltbu8x1">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2.5 bg-bg-card border border-line rounded-[10px] py-2.5 px-3 md:py-3 md:px-4" data-id="element-388" data-mp="267l31xm5ygq5" data-mpi={i}>
                <XCircle className="text-danger shrink-0 mt-0.5" size={16} data-id="element-389" data-mp="1wdcbbc4yirt1" />
                <p className="text-txt-body font-sans text-[13px] md:text-[15px] leading-[1.5]" data-id="element-390" data-mp="218rl9szug3k6">
                  {point}
                </p>
              </div>)}
          </div>

          {/* Divider */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mb-10 md:mb-12" style={{
          background: 'linear-gradient(90deg, transparent 0%, #F5A623 50%, transparent 100%)',
          boxShadow: '0 0 8px rgba(245,166,35,0.4), 0 0 16px rgba(245,166,35,0.2)'
        }} data-id="element-391" data-mp="pt2yb1mlb4jd"></div>

          <h3 className="font-display font-extrabold uppercase md:text-[52px] text-center text-txt-primary mb-8 relative text-[30px]" data-id="element-392" data-mp="3o6994cd9k19d">
            ¿HASTA CUÁNDO VAS A SEGUIR VIENDO EL{' '}
            <span className="text-brandYellow inline-block" style={{
            textShadow: '0 0 20px rgba(255,230,0,0.4), 0 0 40px rgba(255,230,0,0.2)'
          }} data-id="element-393" data-mp="3e7th876ewnyt">
              CRECIMIENTO DIGITAL
            </span>{' '}
            DESDE AFUERA?
          </h3>

          <div className="space-y-4 text-txt-body font-sans text-[15px] md:text-base leading-[1.7] mb-10" data-id="element-394" data-mp="18f4uvzvq515n">
            <p data-id="element-395" data-mp="13eqkib6nhf4g">
              Abriste tu negocio porque querías construir algo propio y hacerlo
              crecer.
            </p>
            <p data-id="element-396" data-mp="1fyvyylb8v60i">
              Le dedicaste tiempo, esfuerzo y dinero para llegar hasta acá. Pero
              sabés que vender solo desde el local hoy ya no alcanza.
            </p>
            <p data-id="element-397" data-mp="1pp8rp0t7q5hq">
              Querés aprovechar Mercado Libre para llegar a más clientes, pero
              no sabés por dónde empezar ni cómo hacerlo correctamente.
            </p>
          </div>

          {/* Highlighted closing question */}
          <div className="relative bg-bg-card border-2 border-brandYellow rounded-[16px] py-5 px-5 md:py-6 md:px-8 shadow-[0_0_20px_rgba(255,230,0,0.1)]" data-id="element-398" data-mp="x1cmf7pkv59c">
            <p className="font-display font-extrabold text-[20px] md:text-[28px] leading-[1.2] text-center text-txt-primary" data-id="element-399" data-mp="1619e7i79kk8m">
              ¿Y si este fuera el{' '}
              <span className="text-brandYellow" data-id="element-400" data-mp="2dejok77fzfql">primer paso</span>
              <br data-id="element-401" data-mp="2hfdboyd28qif" />
              para{' '}
              <span className="text-brandYellow" data-id="element-402" data-mp="2hihim3hwu0cs">multiplicar tus ventas</span>?
            </p>
          </div>

          {/* Divider — transition to product */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mt-10 md:mt-14" style={{
          background: 'linear-gradient(90deg, transparent 0%, #F5A623 50%, transparent 100%)',
          boxShadow: '0 0 8px rgba(245,166,35,0.4), 0 0 16px rgba(245,166,35,0.2)'
        }} data-id="element-403" data-mp="2b1g3v1ghqykd"></div>
        </FadeIn>
      </div>
    </Section>;
};